export default "__VITE_ASSET__EPJkb7Y5__"